const STORAGE_PREFIX = "smartRouteSlot:";

export { isExplicitDriveDeparture } from "./travelDatetimeUtils";

function storedHopMinutes(slot) {
  if (!Array.isArray(slot?.driveHopMinutes)) return [];
  return slot.driveHopMinutes
    .map((minutes) => Math.round(Number(minutes)))
    .filter((minutes) => Number.isFinite(minutes) && minutes > 0)
    .slice(0, 8);
}

export function writeSmartRouteSlot(restaurantId, slot) {
  if (!restaurantId || !slot?.pickupWindow || !slot?.date) return;
  try {
    const previous = readSmartRouteSlot(restaurantId);
    const driveHopMinutes = Object.prototype.hasOwnProperty.call(slot, "driveHopMinutes")
      ? storedHopMinutes(slot)
      : storedHopMinutes(previous);
    const driveHopKey = Object.prototype.hasOwnProperty.call(slot, "driveHopKey")
      ? slot.driveHopKey || null
      : previous?.driveHopKey || null;
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${restaurantId}`,
      JSON.stringify({
        pickupWindow: slot.pickupWindow,
        pickupDate: slot.date,
        arrivalTime: slot.arrivalTime || null,
        source: slot.source || "drive",
        savedAt: Date.now(),
        userDepartureIso: slot.userDepartureIso || null,
        timingMode: slot.timingMode || "default",
        showFullDetails: !!slot.showFullDetails,
        driveMinutes: slot.driveMinutes ?? null,
        prepMinutes: slot.prepMinutes ?? null,
        slotRemainingOrders: slot.slotRemainingOrders ?? null,
        timing: slot.timing || null,
        bookableSlots: Array.isArray(slot.bookableSlots) ? slot.bookableSlots : [],
        notBeforeIso: slot.notBeforeIso || null,
        notAfterIso: slot.notAfterIso || null,
        driveStopIndex: slot.driveStopIndex ?? null,
        isDriveAddOn: !!slot.isDriveAddOn,
        preferredPickupWindow: slot.preferredPickupWindow || null,
        preferredPickupDate: slot.preferredPickupDate || null,
        driveRelatedOrderIds: Array.isArray(slot.driveRelatedOrderIds)
          ? slot.driveRelatedOrderIds.filter(Boolean).slice(0, 20)
          : [],
        restaurantDrive: !!slot.restaurantDrive,
        driveOrigin: slot.driveOrigin?.formattedAddress
          ? {
              formattedAddress: String(slot.driveOrigin.formattedAddress),
              lat: Number(slot.driveOrigin.lat),
              lng: Number(slot.driveOrigin.lng),
              placeId: slot.driveOrigin.placeId || null,
            }
          : null,
        driveHopMinutes,
        driveHopKey,
      }),
    );
  } catch {
    /* ignore quota errors */
  }
}

export function readSmartRouteSlot(restaurantId) {
  if (!restaurantId) return null;
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${restaurantId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.pickupWindow || !parsed?.pickupDate) return null;
    if (parsed.savedAt && Date.now() - parsed.savedAt > 2 * 60 * 60 * 1000) {
      sessionStorage.removeItem(`${STORAGE_PREFIX}${restaurantId}`);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearSmartRouteSlot(restaurantId) {
  if (!restaurantId) return;
  try {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${restaurantId}`);
  } catch {
    /* ignore */
  }
}

/** Drop any drive-route slot hints when leaving drive explore (e.g. switch to near me). */
export function clearAllSmartRouteSlots() {
  try {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(STORAGE_PREFIX)) keysToRemove.push(key);
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    /* ignore */
  }
}
